/** 来源：三家输入控件；用主题 token 统一高度、颜色、焦点环和圆角。
    焦点环按 §9.3 用 focus-visible（仅键盘焦点出 3px 环）；边框主色仍挂 focus，鼠标点选也有反馈。
    hover 态用 --color-line-strong（各主题 line 加深一档的配套 token，见 themes.css）给边框一点反馈。
    层叠注意：class 书写顺序不影响优先级，只看生成 CSS 的顺序与特异性——focus 变体在 Tailwind 的
    variant 排序里生成在 hover 之后，故 focus 主色边框天然压过 hover；error 见下方 errorClasses 注释。 */
const controlClasses = 'min-h-[var(--control-height)] min-w-0 rounded-[var(--radius-md)] border border-[var(--color-line)] hover:border-[var(--color-line-strong)] bg-[var(--color-panel)] px-3 py-1.5 text-sm text-[var(--color-ink)] transition-[border-color,box-shadow] placeholder:text-[var(--color-placeholder)] focus:border-[var(--color-primary)] focus:outline-none focus-visible:ring-[3px] focus-visible:ring-[var(--color-focus)] disabled:cursor-not-allowed disabled:opacity-50'

const widthClassPattern = /(?:^|\s)!?(?:w-|max-w-|min-w-)/
// error 态连 hover 也锁定危险边框：hover 伪类特异性 (0,2,0) 高于无 variant 的 border-danger (0,1,0)，
// 且 hover:border-danger 与 controlClasses 的 hover:border-line-strong 同特异性、生成顺序按类名排序
// line-strong 在后——不加 important 悬停会把错误红框反杀成灰框（实测 tailwindcss 4.3.3 构建产物）。
const errorClasses = 'border-[var(--color-danger)] hover:border-[var(--color-danger)]! focus:border-[var(--color-danger)] focus-visible:ring-[var(--color-danger-soft)]'

/** 调用方给了宽度类则不再内建 w-full，避免 FilterBar 的 w-40 被同层 w-full 盖掉。 */
export function controlClassName(className = '', error = false): string {
  const width = widthClassPattern.test(className) ? '' : 'w-full'
  return `${width} ${controlClasses} ${error ? errorClasses : ''} ${className}`.trim()
}
